import { useCustomHistory } from "hooks";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

function useSuccesOrder() {
  const router = useCustomHistory();
  const params = useParams();
  const { DomainType } = useSelector((state) => state.AppReducer);

  const successPlaceOrder = (orderNumber) => {
    const url = "/order/order-success/";
    router(
      `${url}${orderNumber}`,
      `/${params.domainName}${url}${orderNumber}`,
      DomainType
    );
  };
  return successPlaceOrder;
}

export default useSuccesOrder;
